module.exports = __webpack_public_path__ + "static/media/donation-hero.d920306d.png";